import { render, staticRenderFns } from "./terminalDetail.vue?vue&type=template&id=029566b0&scoped=true&"
import script from "./terminalDetail.vue?vue&type=script&lang=js&"
export * from "./terminalDetail.vue?vue&type=script&lang=js&"
import style0 from "./terminalDetail.vue?vue&type=style&index=0&id=029566b0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "029566b0",
  null
  
)

export default component.exports